import { ChangeDetectionStrategy, Component, ElementRef, OnChanges, input } from '@angular/core';
import { DotCMSContentlet } from 'dotcms/src/lib/models';

import { DomService } from 'ish-core/utils/dom/dom.service';

@Component({
  selector: 'custom-dot-cms-edit-contentlet-wrapper',
  templateUrl: './dot-cms-edit-contentlet-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DotCmsEditContentletWrapperComponent implements OnChanges {
  readonly contentlet = input<DotCMSContentlet>(undefined);

  constructor(private elementRef: ElementRef, private domService: DomService) {}
  ngOnChanges(): void {
    this.setDataAttribute('data-dot-object', 'contentlet');
    const contentlet = this.contentlet();
    this.setDataAttribute('data-dot-inode', contentlet.inode);
    this.setDataAttribute('data-dot-identifier', contentlet.identifier);
    this.setDataAttribute('data-dot-type', contentlet.contentType);
    this.setDataAttribute('data-dot-basetype', contentlet.baseType);
    //this.setDataAttribute('data-dot-lang', this.contentlet);
    this.setDataAttribute('data-dot-title', contentlet.title);
    this.setDataAttribute('data-dot-can-edit', 'true');
    //this.setDataAttribute('data-dot-content-type-id', this.contentlet);
    this.setDataAttribute('data-dot-has-page-lang-version', 'true');
  }
  setDataAttribute(key: string, value: string) {
    if (!!key && !!value) {
      this.domService.setAttribute(this.elementRef.nativeElement, key, value);
    }
  }
}
